import React, { useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"

import notification from "../../assets/Header_Icons/notification.svg"
import notificationDark from "../../assets/Header_Icons/notification_dark.svg"
import { useDarkMode } from "../../context/DarkModeContext"
import {
    UpdateNotificationAsRead
} from "../../services/mutations.js"
import { GetUserNotificationCount, GetUserNotificationList } from "../../services/queries.js"
import Loader from "../Common/Loader/loader.js"
import Modal from "../Common/Modal"
import NotificationList from "./notificationList"
import { generateURL } from "./NotificationUtils"

const Notification = () => {
    const { t } = useTranslation()
    const { isDarkMode } = useDarkMode()
    const [showModal, setShowModal] = useState(false)
    
    // Choose notification image based on dark mode
    const notificationImage = isDarkMode ? notificationDark : notification
    const [pagination, setPagination] = useState({
        pageIndex: 1,
        pageSize: 10
    })
    const [notificationData, setNotifications] = useState([])
    const loginDetails = sessionStorage.getItem("userDetails")
    const loggedInUserDetails = loginDetails
        ? JSON.parse(loginDetails)?.user_details
        : {}
    const isloading = useRef(false)
    const { data: notifications, status: notificationfetchStatus } =
        GetUserNotificationList(loggedInUserDetails?.id, 
            pagination.pageIndex, pagination.pageSize) //Hardcoded Username need to be removed

    const { data: notificationCount } =
        GetUserNotificationCount(loggedInUserDetails?.id)
    
    const { mutateAsync: markNotificationAsRead } = UpdateNotificationAsRead()

    useEffect(() => {
        if (notificationfetchStatus === "success") {
            setNotifications([...notificationData,...(notifications?.data || [])])
            if (notifications?.total_count) {
                totalnoOfPages.current = Math.ceil(notifications?.total_count || 0 / pagination.pageSize)
            }
        }
    }, [notificationfetchStatus])

    const toggleModal = () => {
        document.body.style.overflow = !showModal ? "hidden": "auto"
        setShowModal(!showModal)
    }

    const handleRead = async(id, url_id, entity_id, isRead) => {
        try {
            if (!isRead) {
                isloading.current = true
                await markNotificationAsRead(id)
            }

        } catch (ex) {
            console.log("error on notification read update", ex)
        } finally {
            const URI = generateURL(url_id, entity_id)
            if (URI) {
                window.location.href = URI
            } 
            isloading.current = false
            toggleModal()
        }
        
        
    }

    const onfetch = () => {       
        setPagination({ ...pagination,  pageIndex: pagination.pageIndex + 1 })
    }

    const totalnoOfPages = useRef(0)



    return (
        <>
            <div className="flex">
                <button type="button" className="flex h-full" onClick={ toggleModal }>
                    <>
                        <img src={ notificationImage } height={ "32px" } width={ "32px" } alt={ "notification" }/>
                        <div className="flex w-[22px] h-[22px] 
                          flex-col justify-center items-center shrink-0 gap-2.5 
                          border rounded-full background bg-tertiary-500 relative 
                          right-[11px] bottom-[7px] solid border-white">
                            <span className="text-white text-xs font-bolder text-right pt-[2px]">
                                { notificationCount>9?`${9}+`: notificationCount|| 0 }
                            </span>
                        </div>
                    </>
                </button>
            </div>
            { showModal && (
                <Modal
                    title={ t("Notification.popupTitle") }
                    isCloseOnTop={ true }
                    onTopClose={ toggleModal }
                    notificationCount={ notificationCount || 0 }
                    WrapperClass={ "!w-[50%]" }
                    contentClass={ "!overflow-hidden" }
                >
                    { notificationfetchStatus === "error" && (
                        <p>{ t("common.errorFetchingData") }</p>
                    ) }
                    { notificationfetchStatus === "pending" && <Loader loading={ true } /> }
                    { notificationfetchStatus === "success" && (
                        <NotificationList
                            notifications={ notificationData }
                            totalRecords={ totalnoOfPages.current || 0 }
                            pageLimit={ pagination.pageSize }
                            currentPage= { pagination.pageIndex }
                            isfetching={ notificationfetchStatus === "pending" || isloading.current === true }
                            handleReadAndRedirect={ handleRead }
                            toggleModal={ toggleModal }
                            onfetch={ onfetch }
                        />
                    ) }
                </Modal>
            ) }
        </>
    )
}

export default Notification
